import React from 'react';

import { observer } from 'mobx-react';

import { Link } from '@infoods/lifebase-ui';

import classes from './NgzEntityStatusInfo.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { useStatusDetails } from './hooks/useStatusDetails';
import { useEntityTaxUpdate } from '../../../payment';
import { getNeedToSetupInfo } from './utils/getNeedToSetupInfo';
import { solutionsStore } from '../../../shared/stores/solutionsStore';
import {
  SOLUTION_TYPE,
  SolutionType,
} from '../../../shared/constants/user-info/solutionType';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';

type EntityStatusInfoProps = {
  solution: SolutionType;
};

const subscriptionPageMap: Record<SolutionType, string> = {
  [SOLUTION_TYPE.NUTRITION]: '#!/subscriptions/nutrition',
  [SOLUTION_TYPE.SCAN_IQ]: '#!/subscriptions/scan-iq',
  [SOLUTION_TYPE.CHALLENGE]: '#!/subscriptions/challenge',
};

const linkTitleMap: Record<SolutionType, string> = {
  [SOLUTION_TYPE.NUTRITION]: 'Open Subscriptions page',
  [SOLUTION_TYPE.SCAN_IQ]: 'Open Subscriptions page',
  [SOLUTION_TYPE.CHALLENGE]: 'Open Billing Setup',
};

const EntityStatusInfo = observer(({ solution }: EntityStatusInfoProps) => {
  const { unconfigured, getStatusDetails } = useStatusDetails(solution);

  useEntityTaxUpdate(solution, () => getStatusDetails());

  const isHideStatusInfo = !unconfigured.length;

  if (isHideStatusInfo) {
    return null;
  }

  const needToSetupInfo = getNeedToSetupInfo(unconfigured);

  return (
    <div className={classes.box}>
      <p>
        To activate your profile and make your coaching services available to potential
        clients, please {needToSetupInfo}
      </p>
      <Link href={subscriptionPageMap[solution]} className={classes.link}>
        {linkTitleMap[solution]}
      </Link>
    </div>
  );
});

const NgzEntityStatusInfo = observer(() => {
  const { activeSolution } = solutionsStore;
  const { isEntity, paymentFlowType } = loggedInUserDataStore;

  const isGetStatusDetailsAllowed =
    isEntity && paymentFlowType.NEW_USER_FLOW_2024 && activeSolution;

  if (!isGetStatusDetailsAllowed) {
    return;
  }

  return <EntityStatusInfo solution={activeSolution} />;
});

angularizeWithProviders(NgzEntityStatusInfo, 'ngzEntityStatusInfo', {});

export { NgzEntityStatusInfo };
